import React, { createRef, useState } from 'react';
import { Button, Box } from '@mui/material';
import UploadIcon from '../../assets/icons/upload-icon';

function validateFileInput(file: any) {
  const validFileExtensions = ['csv', 'txt', 'fl2', 'patch', 'xml', 'pb'];
  const fileExtension = file.name.split('.').pop();
  const isValidExtension = validFileExtensions.includes(fileExtension);

  if (!isValidExtension) {
    return `${file.name}: Invalid file type.`;
  }
  return '';
}

const FileUploader = ({
  handleFile,
  buttonId,
  text,
  multiple,
  // accept = ".csv,.txt,.fl2,.patch,.xml,.pb",
  accept = "*",
  enabled,
}: {
  handleFile: Function;
  buttonId?: string;
  text?: string;
  multiple?: boolean;
  accept?: string;
  enabled?: boolean;
}) => {
  const hiddenFileInput = createRef<HTMLInputElement>();
  const [errorMessage, setErrorMessage] = useState('');

  const handleClick = () => {
    if (hiddenFileInput && hiddenFileInput.current) {
      hiddenFileInput.current.value = "";
      hiddenFileInput.current.click();
    }
  };
  let enableUpload = enabled;
  
  const handleChange = async (event: any) => {
    const selectedFile = multiple ? event.target.files : event.target.files[0];

    if (multiple) {
      handleFile(selectedFile);
      return;
    }

    // const validationError = validateFileInput(selectedFile);
    // if (validationError) {
    //   setErrorMessage(validationError);
    //   return;
    // }

    // setErrorMessage('');
    handleFile(selectedFile);
  };

  if (enableUpload === undefined) enableUpload = true;
  return (
    <>
      {errorMessage && <Box style={{ color: 'red' }} mb={1}>{errorMessage}</Box>}
      <Button
        disabled={!enableUpload}
        id={buttonId || 'upload-button'}
        style={{ padding: '0.3rem 1rem', fontSize: '12px' }}
        onClick={handleClick}
        variant="outlined"
        color={errorMessage ? "error" : "primary"}
        size="small"
        startIcon={<UploadIcon />}
      >
        {text || 'Upload'}
      </Button>
      <input
        id={`${buttonId}-hidden-input` || 'upload-hidden-input'}
        type="file"
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: 'none' }}
        multiple={multiple}
        accept={accept}
      />
    </>
  );
};
export default FileUploader;
